<template>
  <div v-if="retailerId === 'SOF'" class="wrapper">
    <h1 class="sof-h1">
        <span v-if="error == 'The order is not currently scheduled'"> You can track your order in real time on delivery day!</span>
        <span v-else> {{ error }} </span>
    </h1>
  </div>
  <div v-else class="wrapper">
    <h1 class="header header--margin-bottom text text--danger text--align-center text--big-lineheight">
        <i class="fas fa-exclamation-circle"></i>
        <span v-if="error == 'The order is not currently scheduled'"> Please check on the day of your delivery</span>
        <span v-else> {{ error }} </span>
    </h1>
  </div>
</template>
<script>
export default {
  name: "DeliveryError",
  props: ['retailerId', 'error']
}
</script>
<style lang="scss">
  .sof-h1 {
    text-align: center;
    font-size: 20px;
    line-height: 1.2;
    margin: 20px 0;
    @media (min-width: 768px) {
      font-size: 24px;
      margin: 30px 0;
    }
  }
</style>
